// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"221":"paragon-theme-core","457":"paragon-theme-variants-light","524":"app"}[chunkId] + "." + {"221":"d83a38941b75d7b9dc13","457":"572cbf14cc0176080a11","524":"8d4c01a4138303983ea8"}[chunkId] + ".css";
};